import { CLEAR_SINGLE_CATEGORY_FILE, FETCH_SINGLE_CATEGORY_FILE, SET_SINGLE_CATEGORY_FILE } from "../actions";

export const getSingleCategoryFile = (collectionId , categoryId) => ({
    type: FETCH_SINGLE_CATEGORY_FILE,
    payload: { collectionId , categoryId },
});

export const setSingleCategoryFile = (categoryData) => ({
    type: SET_SINGLE_CATEGORY_FILE,
    payload: categoryData,
});

export const clearSingleCategoryFile = () => ({
    type: CLEAR_SINGLE_CATEGORY_FILE,
});
